module.exports = __webpack_public_path__ + "img/arr080.c82a9f7b.svg";